export default __webpack_public_path__ + "static/app-perks-c579fec75b073b70621597d7c02e204a.png";